import React from 'react'
import { useHistory } from 'react-router-dom'
import { BreadcrumbView } from '../../../../../context/breadcrumb.context'
import { Form, FormCheckbox, FormSubmitBack, FormText, FormTextArea } from '../../../../../shared/form/form'
import { IconAdd } from '../../../../../shared/icon/icon'
import { Card } from '../../../../../shared/card/card'
import { useApiFormRoleOrg } from '../../../../../api-new/state/content'
import { serverMessage } from '../../../../../shared/error/server-message'
import { ErrorReference } from '../../../../../shared/error/error-reference'
import { useErrorLine } from '../../../../../shared/error/use-error-line'

export const RoleOrgAdd = () => {
	const history = useHistory()

	const apiFormRoleOrg = useApiFormRoleOrg()

	const [error, failure, setError] = useErrorLine()

	// No "Auto Owner" here: the owner role is locked, and a new role can't be
	// it while one exists (the content API answers 409 role.owner_unique).
	const handleSubmit = async (data) => {
		setError(null)
		try {
			await apiFormRoleOrg.post(data)
		} catch (err) {
			setError(serverMessage(err, "The role couldn't be added."), err)
			return
		}
		history.goBack()
	}

	return (
		<React.Fragment>
			<BreadcrumbView Icon={IconAdd} text="Add role">
				<Card title='Add role'>
					{error && <p className='text-danger' role='alert'>{error}</p>}
					{error && <ErrorReference error={failure} className='mb-3' />}
					<Form onSubmit={handleSubmit}>
						<FormText label='name' name='name' autoFocus />
						<FormTextArea label='description' name='description' />
						<FormCheckbox label='Auto User' name='isAutoUser' />
						<FormCheckbox label='Read Only' name='isReadOnly' />
						<FormSubmitBack text='add role' />
					</Form>
				</Card>
			</BreadcrumbView>
		</React.Fragment>
	)
}
